export default __webpack_public_path__ + "static/media/profile.64a59700.jpg";